import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  message,
}) => {
  const modalRef = useRef(null);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      animation
      transition={{ nodeRef: modalRef }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title || "Confirm Action"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center gap-3">
          <img
            src="/assets/images/danger-icon.svg"
            alt="Danger"
            style={{ width: "24px", height: "24px" }}
          />
          <p
            style={{
              color: "red",
              fontWeight: "500",
              marginBottom: "0",
            }}
          >
            {message || "Are you sure you want to proceed?"}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="c-b-btn" onClick={handleClose}>
          Cancel
        </button>
        <button className="n-u-btn" onClick={handleConfirm}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
